// Initial state
import refreshCssVars from '@/utils/cssVarsManager'
import { EnumCanalAtendimentoOrigem } from '@/constants/EnumCanalAtendimentoOrigem'

const initialState = () => ({
  config: null,
  embedJson: null,
  funcionalidade: null,
  bundleWeb: '',
  bundle: '',
  frameId: '',
  plataforma: false,
  apiAcesso: {},
  apiFuncionalidade: {},
  apiCMS: {},
  apiTermoDeUso: {},
  apiGrupoFamiliar: {},
  apiSolicitacao: {},
  apiOcorrenciaBeneficiario: {},
  apiPesquisa: {},
  apiRedirect: {},
  apiChavePasse: {},
  apiOcorrenciaPublico: {},
  apiOcorrenciaAtendente: {},
  apiUtilitarios: {},
  apiFormPreLoadData: {},
  esquemaDeCor: null,
  keepHeightUpdated: true,
  canal: 'appEmbed'
})

// root state object.
// each Vuex instance is just a single state tree.
const state = initialState

// getters are functions
const getters = {
  bundle: state => ((state.config || {}).aplicacao || {}).bundle,
  bundleWeb: state => state.bundleWeb,
  aplicacao: state => (state.config || {}).aplicacao,
  estilo: state => state.esquemaDeCor || {},
  estiloFormBuilder: (state) => {
    const colors = (state.esquemaDeCor || {}).formBuilder

    if (!colors) {
      return {}
    }

    return {
      primary: colors.corPrincipalFormBuilder,
      errors: colors.corErroFormBuilder,
      alert: colors.corAlertaFormBuilder
    }
  },
  mensageria: state => (state.config || {}).mensageria,
  liveNow: state => (state.config || {}).liveNow,
  dashBoard: state => (state.config || {}).dashBoard,
  tabBar: state => (state.config || {}).tabBar,
  configuracaoAcesso: state => (state.config || {}).configuracaoAcesso,
  instanciaAplicacao: state => (state.embedJson || {}).instanciaAplicacao || process.env.VUE_APP_INSTANCIA_APLICACAO_DEFAULT,
  canalAtendimentoOrigem: state => (state.embedJson || {}).canalAtendimentoOrigem || EnumCanalAtendimentoOrigem.PLATAFORMA_BENEFICIARIO,
  isWidget: state => (state.embedJson || {}).canalAtendimentoOrigem === EnumCanalAtendimentoOrigem.MOSIA_DESK,
  funcParams: state => (state.funcionalidade || {}).parametros || {},
  textoVinculoContrato: (state) => {
    if (state.config && state.config.aplicacao && state.config.aplicacao.textos && state.config.aplicacao.textos.vinculoContrato) {
      return state.config.aplicacao.textos.vinculoContrato
    }

    return 'Contrato'
  }
}

// actions are functions that cause side effects and can involve
// asynchronous operations.
const actions = {
  initialStateSetup ({ commit }) {
    commit('INITIAL_STATE')
  },
  setKeepHeightUpdated ({ commit }, keepHeightUpdated) {
    commit('SET_KEEP_HEIGHT_UPDATED', keepHeightUpdated)
  }
}

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  SET_CONFIG (state, payload) {
    state.config = payload.config
    state.bundleWeb = payload.bundleWeb
    state.bundle = payload.bundle
    state.embedJson = payload.json
    state.frameId = payload.frameId
    state.plataforma = payload.plataforma
    state.canal = payload.canal ? payload.canal : 'appEmbed'
    state.numeroChamado = payload.numeroChamado
    state.protocolo = payload.protocolo
    state.origemEmbed = payload.origemEmbed
  },
  SET_FUNCIONALIDADE (state, payload) {
    state.funcionalidade = payload
    state.idFuncionalidade = payload.idFuncionalidade
  },
  SET_ID_FUNCIONALIDADE (state, payload) {
    state.idFuncionalidade = payload
  },
  SET_API_FUNCIONALIDADE (state, payload) {
    state.apiFuncionalidade = payload
  },
  SET_API_ACESSO (state, payload) {
    state.apiAcesso = payload
  },
  INITIAL_STATE (state) {
    const initial = initialState()
    Object.keys(initial).forEach(key => {
      state[key] = initial[key]
    })
  },
  SET_API_APLICACAO (state, payload) {
    state[payload.apiNome] = payload.rotas
  },
  SET_ESQUEMA_DE_COR (state, payload) {
    if (!payload) {
      return
    }
    state.esquemaDeCor = payload
    refreshCssVars(payload)
  },
  SET_KEEP_HEIGHT_UPDATED (state, keepHeightUpdated) {
    state.keepHeightUpdated = keepHeightUpdated
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
